var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBiller(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689",
    transform: "translate(-261 -705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683",
    transform: "translate(-11 533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    transform: "translate(272 173)",
    fill: "#fff",
    stroke: "#8b9095",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 14,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 13,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680",
    transform: "translate(-18.926 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 3,
    height: 1,
    transform: "translate(292.926 175)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 7,
    height: 1,
    transform: "translate(292.926 178)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    width: 7,
    height: 1,
    transform: "translate(292.926 180)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 7,
    height: 1,
    transform: "translate(292.926 182)",
    fill: "#8b9095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_666",
    "data-name": "Ellipse 666",
    transform: "translate(278 172)",
    fill: "#fff",
    stroke: "#8b9095",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M13.5,11.082H11.685V9.266a.3.3,0,0,0-.6,0v1.816H9.266a.3.3,0,0,0,0,.6h1.817V13.5a.3.3,0,0,0,.6,0V11.685H13.5a.3.3,0,1,0,0-.6Z",
    transform: "translate(270.615 164.616)",
    fill: "#8b9095"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBiller);
export default __webpack_public_path__ + "static/media/add-biller.f59856a4.svg";
export { ForwardRef as ReactComponent };